// extracted by mini-css-extract-plugin
module.exports = {"root":"TabDocs_root__1FkU8","fileImg":"TabDocs_fileImg___eCQo"};